import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EventActionEnum, EventCategoryEnum } from '@core/services/analytics';
import { ChangableComponent } from '@models/changable.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AnalyticsService, AuthModalModeType, AuthService, ScreenService } from '../../services/';

@Component({
  selector: 'app-auth-modal',
  templateUrl: './auth-modal.component.html',
  styleUrls: ['./auth-modal.component.scss'],
})
export class AuthModalComponent extends ChangableComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  deviceService = inject(DeviceDetectorService);
  screenService = inject(ScreenService);
  private authService = inject(AuthService);
  private analytics = inject(AnalyticsService);

  @Input() public view: AuthModalModeType = null;
  @Input() public caller: string; // Caller
  @Input() public reason: string; // Call reason

  @Output() public on_closed = new EventEmitter<boolean>();

  /*
   */
  public ngOnInit(): void {
    this.authService.backUrl = window.location.pathname;
    if (!document.body.classList.contains('fixed')) {
      document.body.classList.add('fixed');
    }
    this.analytics.event(EventActionEnum.auth_opened, EventCategoryEnum.engagement, this.eventLabels());
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (document.body.classList.contains('fixed')) {
      document.body.classList.remove('fixed');
    }
  }

  protected eventLabels(): string[] {
    return [this.caller, this.reason];
  }

  /*
   */
  public closed = () => this.on_closed.emit(true);
  public set_view = (name: AuthModalModeType) => (this.view = name);

  /* Todo.
   */
  public on_form_submit(data) {
    if (data?.set_view as AuthModalModeType) {
      this.view = data?.set_view as AuthModalModeType;
      return;
    }

    if (data?.success === true) {
      this.analytics.event(
        data?.action == 'signin' ? EventActionEnum.signin_succeed : EventActionEnum.signup_succeed,
        EventCategoryEnum.engagement,
        this.eventLabels(),
      );
      this.goToUrl();
    }
  }

  /*
   */
  public goToUrl() {
    console.log('AuthService backUrl', this.authService.backUrl);
    if (!!this.authService.backUrl.length && this.authService.backUrl !== '/') {
      this.router.navigate([this.authService.backUrl]).then(() => {
        this.authService.backUrl = '';
      });
    } else {
      this.router.navigate(['/main']).then();
    }
  }
}
